import { createAction, props } from '@ngrx/store';
import { CatalogsInterface } from './catalogs.models';
import { CatalogRequest } from '@core/services/common/catalog-operation';

export const loadCatalogs = createAction('[Catalogs] Load', props<CatalogRequest>());
export const loadCatalogsSuccess = createAction(
  '[Catalogs] Load Success',
  props<CatalogRequest & { catalogs: CatalogsInterface }>(),
);
export const loadCatalogsFailure = createAction('[Catalogs] Load Failure', props<CatalogRequest & { error: string }>());
export const resetCatalogs = createAction('[Catalogs] Reset');
export const refreshCatalogs = createAction('[Catalogs] Refresh');
